import React from 'react';
import ChatInput from './ChatInput';

/**
 * ChatFooter component for displaying the chat input and disclaimer
 */
const ChatFooter = ({
    onSendMessage,
    disabled,
    selectedModel,
    onModelChange,
    aiModels,
    isChatLoading,
    inputText,
    onInputChange,
    selectedChatId,
    selectedInstrument,
    selectedCategory,
    inputRef,
    onDisabledInputClick,
    onStopGeneration,
    isStreaming
}) => {
    return (
        <div className="ntb-chat-footer">
            <ChatInput
                onSendMessage={onSendMessage}
                disabled={disabled}
                selectedModel={selectedModel}
                onModelChange={onModelChange}
                aiModels={aiModels}
                isChatLoading={isChatLoading}
                value={inputText}
                onChange={onInputChange}
                selectedChatId={selectedChatId}
                selectedInstrument={selectedInstrument}
                selectedCategory={selectedCategory}
                inputRef={inputRef}
                onDisabledInputClick={onDisabledInputClick}
                onStopGeneration={onStopGeneration}
                isStreaming={isStreaming}
            />
        </div>
    );
};

export default ChatFooter; 